import { render, staticRenderFns } from "./bodyprint-view.vue?vue&type=template&id=126b9dca"
import script from "./bodyprint-view.vue?vue&type=script&lang=js"
export * from "./bodyprint-view.vue?vue&type=script&lang=js"
import style0 from "./bodyprint-view.vue?vue&type=style&index=0&id=126b9dca&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports